<template>
  <div class="detail-page">
    <page-header :title="title">
      <template v-if="$slots.header">
        <slot name="header"></slot>
      </template>
    </page-header>
    <div class="detail-page-body">
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './header.vue'
export default {
  components: { PageHeader },
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
.detail-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  &-body {
    height: 100%;
    background: white;
    overflow: hidden;
    margin-top: 10px;
    & > div {
      padding: 20px;
      max-height: 100%;
      width: 100%;
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail-page/index.vue